import { format } from 'date-fns';
import { FormModificationState } from '@flexible-reports/store/slices/types';

// TODO - Add logic to set a default Name for Initial load of Create Page.
// Sim - https://sim.amazon.com/issues/RCMRX-11047
export const getDefaultReportName = (name?: string): string => {
  const currentTimestamp = format(new Date(), "MM/dd/yyyy'T'HH:mm:ss");
  return `${name || 'Report'} - ${currentTimestamp}`;
};

/**
 * Based on Form State, returns true if form is modified.
 * @param formModificationState
 */
export const isFormModified = (formModificationState: FormModificationState): boolean => {
  return Object.keys(formModificationState).some(key => formModificationState[key as keyof FormModificationState]);
};
